{
  "view": {
    "title": "Parkeringsplatser",
    "parkingSpot": "Parkeringsplats",
    "reserve": "Reservera",
    "details": "Detaljer",
    "parkingArea": "Parkeringsområde",
    "description": "Här kan du se parkeringsplatser och reservera din egen parkeringsplats genom att klicka på önskad plats.",
    "queueDescription": "Reserverade platser kan köas.",
    "reservationsNotSet": "Bokning av parkeringsplatser är inte inställd för den här fastigheten.",
    "complimentaryInfo": "Du har {{count}} gratis parkeringsplatser tillgängliga.",
    "disabledReservationInfo": "Handikapplatser måste bokas via kundservice.",
    "limitReached": "Du har nått maxantalet ({{max}}) parkeringsplatser.",
    "noParkingAreas": "Inga parkeringsområden tillgängliga"
  },
  "legend": {
    "available": "Ledig",
    "reservedOrInactive": "Upptagen",
    "mine": "Min plats",
    "mineUpcoming": "Min plats börjar snart",
    "notInUse": "Inte i bruk",
    "ending": "Slutar snart",
    "starting": "Börjar snart",
    "title": "Förklaringar av ikoner"
  },
  "aria": {
    "availableIndicator": "Färgindikator för ledig plats",
    "reservedIndicator": "Färgindikator för upptagen plats",
    "mineIndicator": "Färgindikator för din egen plats",
    "mineUpcomingIndicator": "Färgindikator för plats som snart börjar",
    "notInUseIndicator": "Färgindikator för en plats som inte används"
  },
  "price": {
    "label": "Pris",
    "free": "Gratis",
    "perMonth": "{{amount}} / mån",
    "fromPerMonth": "från {{amount}} / mån",
    "total": "Totalt"
  },
  "equipment": {
    "covered": "Skärmtak",
    "ev_charger": "Laddning för elbil",
    "garage": "Garage",
    "heating_outlet": "Elstolpe",
    "motorbike_spot": "Motorcykelplats",
    "yard": "Gård",
    "building": "Hus/Hall",
    "disabled_spot": "Handikapplats",
    "covered_motorbike_spot": "Skärmtak motorcykelplats",
    "covered_disabled_spot": "Skärmtak handikapplats",
    "garage_motorbike_spot": "Garage motorcykelplats",
    "garage_disabled_spot": "Garage handikapplats",
    "building_motorbike_spot": "Hus/Hall motorcykelplats",
    "building_disabled_spot": "Hus/Hall handikapplats"
  },
  "tooltip": {
    "reservation": {
      "current": { "label": "Bokning" },
      "future": { "label": "Kommande bokning" },
      "previous": { "label": "Tidigare bokning" }
    },
    "available": "Tillgänglig",
    "openEnded": "(tills vidare)"
  },
  "spot": {
    "label": "Plats",
    "status": "Status",
    "equipment": "Platsens egenskaper",
    "details": "Uppgifter"
  },
  "success": {
    "title": "Bokningen av parkeringsplats lyckades!",
    "starts": "Bokningen börjar"
  },
  "address": {
    "at": "på adressen"
  },
  "effectiveFrom": "Ändringen träder i kraft",
  "acceptRules": "Jag godkänner reglerna för {{address}} och villkoren för bokning av parkeringsplats",
  "date": {
    "placeholder": "dd.mm.åååå"
  },
  "error": {
    "contractMissing": "Avtalsinformation saknas - det går inte att göra en bokning.",
    "reservationFailed": "Bokningen misslyckades. Försök igen om en stund.",
    "overlap": "Den valda parkeringsplatsen kan inte reserveras. Välj en annan plats eller försök igen senare.",
    "terminationFailed": "Avslutningen misslyckades. Försök igen om en stund."
  },
  "terminate": {
    "endDateLabel": "Ändringen träder i kraft",
    "endDateTooEarly": "Slutdatumet måste vara minst {{date}}",
    "cta": "Avsluta bokning",
    "success": "Bokningen avslutad",
    "terminateTitle": "Parkeringsplatsbokningen avslutas",
    "terminateFrom": "Bokningen för parkeringsplats {{spot}} avslutas {{date}}"
  },
  "cancel": {
    "futureReservationLabel": "Bokningen träder i kraft",
    "reservationStartedOn": "Bokningens startdatum {{date}}",
    "cta": "Avboka bokning",
    "success": "Bokningen avbokad",
    "error": {
      "failed": "Avbokningen misslyckades. Försök igen om en stund."
    }
  },
  "queue": {
    "join": "Gå med i kön",
    "leave": "Lämna kön",
    "empty": "Du står inte i parkeringskön.",
    "youAreWaiting": "Du står i kö för en parkeringsplats med: {{features}}",
    "additionalInfoSuffix": ". {{info}}",
    "loading": "Laddar…",
    "loadError": "Fel vid inläsning av parkeringskön."
  },
  "form": {
    "fields": {
      "equipment": {
        "label": "Önskade platstyper",
        "helper": "Välj en eller flera typer (t.ex. gårdsplats, skärmtak, elbilsladdning)."
      },
      "additionalInfo": {
        "label": "Tilläggsinformation",
        "placeholder": "T.ex. behov av laddning eller tidsbegränsning."
      }
    },
    "actions": {
      "cancel": "Avbryt",
      "join": "Gå med i kön"
    },
    "parkingSpotContractDocumentLink": "Regler",
    "parkingSpotTermsOfUseLink": "Reservationsvillkor"
  },
  "errors": {
    "equipmentRequired": "Välj minst en platstyp",
    "equipmentUnavailable": "Du kan inte köa för den valda platstypen eftersom en motsvarande plats är ledig.",
    "joinFailed": "Misslyckades att gå med i kön"
  }
}
